/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Tpm_SuccessInputs */

const en_ticket_action_tpm_success = /** @type {(inputs: Ticket_Action_Tpm_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logged: TPM problem reported.`)
};

const ja_ticket_action_tpm_success = /** @type {(inputs: Ticket_Action_Tpm_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録: TPMの問題を報告しました。`)
};

const fr_ticket_action_tpm_success = /** @type {(inputs: Ticket_Action_Tpm_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré : problème TPM signalé.`)
};

const de_ticket_action_tpm_success = /** @type {(inputs: Ticket_Action_Tpm_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfasst: TPM-Problem gemeldet.`)
};

/**
* | output |
* | --- |
* | "Logged: TPM problem reported." |
*
* @param {Ticket_Action_Tpm_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_tpm_success = /** @type {((inputs?: Ticket_Action_Tpm_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Tpm_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_tpm_success(inputs)
	if (locale === "ja") return ja_ticket_action_tpm_success(inputs)
	if (locale === "fr") return fr_ticket_action_tpm_success(inputs)
	return de_ticket_action_tpm_success(inputs)
});